import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { makeGetRequest, makePostRequest } from 'utils/api'
import { Box, Checkbox, FormControlLabel, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { parseInt } from 'lodash'

export default function ValeurSetting({ setOpenSetting, updateReports }) {
  const [revenuCat, setRevenuCat] = useState([])
  const [open, setOpen] = useState(true)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    fetchValeurSetting()
  }, [])

  const handleClose = () => {
    setOpen(false)
    setSelected([])
    setOpenSetting(false)
  }

  const fetchRevenuCategoryFi = async () => {
    const url = '/api/Finance/Categoriesfi-revenu/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setRevenuCat(data)
    }
  }
  const fetchValeurSetting = async () => {
    const url = '/api/Professional/valeurSettings/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      let ss = []
      data.forEach((e) => {
        ss.push(parseInt(e.element))
      })
      setSelected(ss)
    }
    fetchRevenuCategoryFi()
  }
  const handleSubmit = async () => {
    if (selected.length > 0) {
      let payload = { ids: selected }
      const response = await makePostRequest('/api/Professional/valeurSettings/', payload, {}, true)
      if (response.status === 200) {
        handleClose()
        updateReports()
      }
    } else {
      alert('Please Select categories...')
    }
  }
  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose} className="no-drag">
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 0, right: 0 }}
          aria-label="fingerprint"
          color="secondary"
        >
          <CloseIcon sx={{ color: 'black' }} />
        </IconButton>
        <DialogTitle sx={{ color: '#383838 !important' }}>Categories</DialogTitle>

        <DialogContent>
          <Box
            display={'flex'}
            height={'70vh'}
            width={'100%'}
            borderTop={'1px solid #74b7fd'}
            borderBottom={'1px solid #74b7fd'}
          >
            <Box overflow={'auto'}>
              <Box>
                <TableContainer component={Paper} sx={{ boxShadow: 'unset', pr: '6px' }}>
                  <Table sx={{}} aria-label="spanning table">
                    <TableHead
                      sx={{
                        '.MuiTableCell-root': {
                          padding: '5px 16px',
                          borderBottom: 'unset',
                          fontWeight: 800,
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell align="left">
                          Activercette sous-categorie au revnus professionnelle
                        </TableCell>
                        <TableCell align="left">Categorie</TableCell>
                        <TableCell align="left"></TableCell>
                        <TableCell align="left">Sous Categorie</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{ '.MuiTableCell-root': { padding: '0px', borderBottom: 'unset' } }}
                    >
                      {revenuCat.map((el) => (
                        <TableRow key={el.id}>
                          <TableCell>
                            <FormControlLabel
                              sx={{ display: 'flex', justifyContent: 'center' }}
                              control={
                                <Checkbox
                                  checked={selected.includes(el.id)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelected([...selected, el.id])
                                    } else {
                                      setSelected([...selected.filter((c) => c !== el.id)])
                                    }
                                  }}
                                />
                              }
                            />
                          </TableCell>

                          <TableCell align="center">{el.Categorie}</TableCell>
                          <TableCell align="center" sx={{ width: 100 }}></TableCell>
                          <TableCell align="center">{el.SousCategorie}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit}>Valider</Button>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
